import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getBuyOverageWiresPath = () => {
  return urlHelper(`/checkout/buy-overage-wires`);
};
